<template>
  <b-modal
    :id="id"
    centered
    hide-header
    hide-footer
    no-enforce-focus
    no-close-on-backdrop
    @show="reset"
  >
    <b-form
      @submit.prevent="onSubmit"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem
      "
    >
      <h2 class="mt-3">加入圖片</h2>
      <ValidationObserver ref="form" class="w-100">
        <DropZone
          v-model="imageInput"
          name="文章圖片"
          label="文章圖片"
          sub-label="(檔案大小上限2mb)"
          rules="required"
          required
          upload-type="notificationBlogContentImages"
          :max-files="1"
        ></DropZone>
      </ValidationObserver>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 1.5rem;
        "
        class="my-2"
      >
        <b-button
          @click="$bvModal.hide(id)"
          variant="outline-primary"
          style="flex: 1"
        >
          取消
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          style="flex: 1"
        >
          確認
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import DropZone from '@/components/form/DropZone.vue';
import imagePath from '@/filters/image-path';
import formMixin from '@/mixins/form';
import { BButton, BForm } from 'bootstrap-vue';

export default {
  mixins: [formMixin],
  components: {
    DropZone,
    BButton,
    BForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    htmlCallback: {
      type: Function,
    },
  },
  data: () => ({
    imageInput: '',
  }),
  computed: {
    generatedHTML() {
      return `<p><img style="width: 100%" src="${imagePath(
        this.imageInput,
        'notificationBlogContentImages',
      )}" alt="" /></p><br/>`;
    },
  },
  methods: {
    reset() {
      this.imageInput = '';
    },
    async onSubmit() {
      if ((await this.validate().toPromise()) === undefined) {
        return;
      }
      this.htmlCallback(this.generatedHTML);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
